import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors, gradient, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import { menuIcon } from "../ChromeNav.styles";

export const DEFAULT_NAV_HEIGHT = 60;

//////////////////
// GENERIC
//////////////////
export const container: CSSProperties = {
  display: "flex",
  alignItems: "center",
  height: DEFAULT_NAV_HEIGHT,
};

export const label: CSSProperties = {
  color: colors.blueDusk.standard,
  fontWeight: "bold",
  fontSize: 20,
  marginTop: 1,
  marginLeft: 0,
  marginBottom: 0,
  marginRight: "auto",
};

//////////////////
// BACK BTN
//////////////////
export const backBtn: CSSProperties = {
  padding: 0,
  margin: 12,
  marginLeft: 5,
  width: "auto",
  transition: "all 0.25s ease-in-out",
  "&:hover": {
    backgroundColor: "unset",
    paddingRight: 5,
    transform: "translateX(-5px)",
  },
};

export const backBtnChevron: CSSProperties = {
  color: colors.blueDusk.standard,
  height: 24,
  width: 21,
  marginRight: -2,
};

export const backBtnLogo = {
  fill: colors.blueDusk.standard,
  width: 20,
  height: 24,
};

export const backBtnContent: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

//////////////////
// HOME
//////////////////
export const containerHome: CSSProperties = {
  ...container,
  justifyContent: "space-between",
};

export const logo = {
  fill: colors.blueDusk.standard,
  style: {
    width: 132,
    flexShrink: 0,
  } as CSSProperties,
};

const planTypeBadge: CSSProperties = {
  borderRadius: 3,
  padding: 4,
  textAlign: "center",
  textTransform: "uppercase",
  fontSize: 11,
  fontWeight: "bold",
  cursor: "pointer",
};

const badgeBlue: CSSProperties = {
  ...planTypeBadge,
  background: helpers.opacity(colors.blueDusk.lighter, 0.3),
  color: colors.blueDusk.lighter,
};

const badgeGradient: CSSProperties = {
  ...planTypeBadge,
  background: gradient,
  color: greys.white,
};

export const navCollapseButton = {
  padding: 4,
  marginRight: "5px",
};

export const navCollapse = {
  ...menuIcon,
  transform: "rotate(-90deg)",
  height: 34,
  width: 34,
} as CSSProperties;

/////////////////////
// CALENDAR PROFILE
/////////////////////
export const calProfileContainer: CSSProperties = {
  display: "flex",
  justifyContent: "center",
  padding: 15,
};

export const calProfileBackBtn: CSSProperties = {
  position: "absolute",
  top: 4,
  left: 0,
};

export const calProfileMenu: CSSProperties = {
  position: "absolute",
  top: 4,
  right: 0,
};

export const styles = {
  backBtn,
  backBtnContent,
  navCollapse,
  badgeBlue,
  badgeGradient,
};
